<template>
  <mp-box
    v-if="message"
    id="qon-quota-banner"
    as="div"
    :bg-color="variantStyle.background"
    px="6"
    py="2"
  >
    <mp-flex direction="row" align="center" justify-content="space-between">
      <mp-flex align="center">
        <mp-icon
          name="warning-triangle"
          :color="variantStyle.color"
          variant="fill"
          size="md"
          mr="3"
        />
        <mp-text
          v-dompurify-html="message"
          as="span"
          :color="variantStyle.color"
          is-truncated
        />
      </mp-flex>
      <mp-flex v-if="resolvedButtonText" align="center" ml="3" flex="none">
        <mp-button variant="outline" size="sm" @click="onClickAction">
          {{ resolvedButtonText }}
        </mp-button>
      </mp-flex>
      <mp-box
        v-if="isClosable"
        as="div"
        cursor="pointer"
        ml="3"
        flex="none"
        @click="$emit('close')"
      >
        <mp-icon
          name="close"
          :color="variantStyle.color"
          variant="fill"
          size="md"
        />
      </mp-box>
    </mp-flex>
  </mp-box>
</template>

<script>
const VARIANT_STYLE_MAP = {
  info: { background: 'violet.400', color: 'white' },
  information: { background: 'violet.400', color: 'white' },
  important: { background: 'amber.100', color: 'dark' },
  announcement: { background: 'stone.400', color: 'white' },
}

const DEFAULT_VARIANT_STYLE = { background: 'amber.100', color: 'dark' }

export default {
  name: 'QuotaBanner',
  props: {
    message: {
      type: String,
      default: '',
    },
    bannerColorOrType: {
      type: String,
      default: null,
    },
    button: {
      type: Object,
      default: null,
    },
    isClosable: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  computed: {
    variantStyle() {
      if (!this.bannerColorOrType) {
        return DEFAULT_VARIANT_STYLE
      }

      return VARIANT_STYLE_MAP[this.bannerColorOrType] || DEFAULT_VARIANT_STYLE
    },
    resolvedButtonText() {
      return this.button && this.button.text ? this.button.text : ''
    },
    resolvedButtonUrl() {
      return this.button && this.button.url ? this.button.url : ''
    },
  },
  methods: {
    onClickAction() {
      if (!this.resolvedButtonUrl) {
        return
      }

      if (this.resolvedButtonUrl.startsWith('http')) {
        window.open(this.resolvedButtonUrl, '_blank', 'noopener,noreferrer')
      } else {
        window.location.assign(this.resolvedButtonUrl)
      }
    },
  },
}
</script>
